import { IApplicationState } from '../../types/redux';

export const selectActiveTab = (state: IApplicationState) => state.activeTab;
